<template>
  <div class="addUserMainDiv" ref="addUserMainDiv">
    <PageHeader :title="title" :items="headerItems" />
    <div class="main">
      <div>
        <div>
          <div class="d-flex align-items-center mb-3 p-0">
            <div class="d-flex align-items-center">
              <span class="sectionTitle">اطلاعات کاربر</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="section">
            <div class="mb-3">
              <BaseText @input="formData.firstName = $event" :required="true" :showError="firstNameError" errortext="وارد کردن نام اجباری است" title="نام" placeholder="نام" />
            </div>
            <div class="mb-3">
              <BaseText
                @input="formData.lastName = $event"
                :required="true"
                :showError="lastNameError"
                errortext="وارد کردن نام خانوادگی اجباری است"
                title="نام خانوادگی"
                placeholder="نام خانوادگی"
              />
            </div>
            <div class="mb-3">
              <BaseText
                inputType="number"
                :maxlength="14"
                @input="formData.mobile = $event"
                :required="true"
                :showError="mobileError"
                :errortext="mobileErrorText"
                title="تلفن همراه"
                placeholder="تلفن همراه"
              />
            </div>
            <div class="mb-3">
              <BaseText inputType="number" :maxlength="14" @input="formData.telephone = $event" title="تلفن ثابت" placeholder="تلفن ثابت" />
            </div>
            <div class="mb-3">
              <BaseText inputType="number" :maxlength="10" @input="formData.nationalCode = $event" title="کد ملی" placeholder="کد ملی" />
            </div>
            <div class="">
              <BaseText @input="formData.email = $event" title="ایمیل" placeholder="ایمیل" />
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center mb-3 p-0">
            <div class="d-flex align-items-center">
              <span class="sectionTitle">اطلاعات پستی</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="section">
            <b-row class="mb-3">
              <b-col cols="6">
                <div v-if="forceUpdateFlag">
                  <ComboBox
                    title="استان"
                    placeholder="استان"
                    @selectedItem="selectedProvince($event)"
                    @searchedItem="searchedProvince($event)"
                    :searchedData="searchedProvinceData"
                    @input="selectProvince = $event"
                    :selectedValue="selectProvince"
                  />
                </div>
              </b-col>
              <b-col cols="6">
                <div v-if="resetCityFlag">
                  <ComboBox
                    title="شهر"
                    placeholder="شهر"
                    @selectedItem="selectedCity($event)"
                    @searchedItem="searchedCity($event)"
                    :searchedData="searchedCityData"
                    @input="selectCity = $event"
                    :selectedValue="selectCity"
                    :disabled="cityDisabled"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="12">
                <TextAreaInput @input="formData.address.addressText = $event" title="آدرس" placeholder="آدرس" />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <BaseText inputType="number" :maxlength="10" @input="formData.address.postalCode = $event" title="کد پستی" placeholder="کد پستی" />
              </b-col>
            </b-row>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center mb-3 p-0">
            <div class="d-flex align-items-center">
              <span class="sectionTitle">یادداشت</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="section">
            <div>
              <b-row>
                <b-col cols="12">
                  <TextAreaInput @input="formData.adminNote = $event" title="یادداشت" placeholder="یادداشت" />
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center mb-3 p-0">
            <div class="d-flex align-items-center">
              <span class="sectionTitle">مشخصات کاربر</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="section">
            <b-row>
              <b-col class="d-flex justify-content-start align-items-center" lg="4">
                <i class="fas fa-user-circle userPic" v-if="!UserAvatar"></i>
                <img v-else :src="UserAvatar" alt="" class="user-avatar" />
                <div @click="$bvModal.show('chooseImage')" class="choosePic">
                  انتخاب عکس
                </div>
                <b-modal id="chooseImage" no-close-on-esc hide-footer centered size="md" header header-close-variant="dark" cancel-title>
                  <template #modal-title>کراپ عکس</template>
                  <div class="p-3">
                    <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="changeUserAvatar($event)" />
                  </div>
                </b-modal>
              </b-col>
              <b-col class="d-flex justify-content-start align-items-center" lg="4">
                <FormTags isAddUser @tagListUpdate="tagListUpdate($event)" :tags="FormTagData.tags" />
              </b-col>
              <b-col class="d-grid" lg="4">
                <RangeSlider @rate="userRate($event)" :options="sliderOptions" />
              </b-col>
            </b-row>
          </div>
        </div>
        <div>
          <div class="buttonClass">
            <Button @click.native="submit" btnClass="submitButton" text="ثبت" :loading="disableSubmit" />
            <b-button @click="$bvModal.show('cancleModal')" class="cancleButton">
              <span class="cancleTitle">انصراف</span>
            </b-button>
            <b-modal id="cancleModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
              <div class="error-wrapper">
                <div class="mb-4">
                  <img src="@/assets/images/checked1.svg" />
                </div>
                <div class="error-title">
                  آیا از انصراف خود مطمئن هستید؟
                </div>
                <div class="buttons">
                  <div @click="$bvModal.hide('cancleModal')">
                    <button class="cancelButton">خیر</button>
                  </div>
                  <div @click="goToListPage">
                    <button class="approveButton">بلی</button>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
          <Toast title="لطفا همه اطلاعات را تکمیل کنید" :error="true" :showToast="alertFlag" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/layoutComponents/page-header'
import BaseText from '../common/form/formModules/BaseText.vue'
import TextAreaInput from '../common/form/formModules/TextAreaInput.vue'
import ComboBox from '../common/form/formModules/ComboBox.vue'
import FormTags from '../common/form/formModules/FormTags.vue'
import ImageCropper from '../user/ImageCropper.vue'
import RangeSlider from '../common/rangeSlider.vue'
import { invoiceMixins } from '../../utils/mixins'
import userDataProvider from '../../services/user'
import invoiceDataProvider from '../../services/invoice'
import fileMannager from '../../services/file'
import Toast from '../common/Toast.vue'
import Button from '../common/Button.vue'
export default {
  components: {
    PageHeader,
    BaseText,
    TextAreaInput,
    ImageCropper,
    ComboBox,
    RangeSlider,
    FormTags,
    Toast,
    Button,
  },
  mixins: [invoiceMixins],
  data() {
    return {
      cropperLoading: false,
      headerItems: [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: 'جدول مدیریت کاربران',
          active: true,
        },
      ],
      firstNameError: false,
      lastNameError: false,
      mobileError: false,
      mobileErrorText: 'وارد کردن تلفن همراه اجباری است',
      title: 'مدیریت کاربران',
      disableSubmit: false,
      resetCityFlag: true,
      searchedProvinceData: [],
      searchedCityData: [],
      selectProvince: '',
      selectCity: '',
      cityDisabled: true,
      formData: {
        firstName: null,
        lastName: null,
        telephone: null,
        mobile: null,
        email: null,
        adminNote: null,
        nationalCode: null,
        fatherName: null,
        companyId: null,
        customerSatisfactionRate: 0,
        address: {
          cityId: 0,
          addressText: null,
          postalCode: null,
        },
        tag: [],
      },
      FormTagData: {
        newTagPlaceholder: 'اضافه کردن تگ',
        tags: [],
        newTag: '',
      },
      sliderOptions: {
        text: 'رضایت از مشتری',
        dotSize: 0,
        width: '100%',
        height: 7,
        contained: false,
        direction: 'rtl',
        dataLabel: 'label',
        dataValue: 'value',
        min: 0,
        max: 10,
        interval: 1,
        disabled: false,
        clickable: true,
        duration: 1,
        adsorb: false,
        lazy: true,
        tooltip: 'always',
        tooltipPlacement: 'top',
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: true,
        enableCross: true,
        fixed: false,
        order: true,
        marks: {
          '0': '0',
          '10': '10',
        },
        process: true,
        processStyle: { backgroundColor: '#556ee6' },
        tooltipStyle: { backgroundColor: '#556ee6', borderColor: '#556ee6', height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2px 1px' },
      },
      UserAvatar: null,
      alertFlag: false,
      forceUpdateFlag: true,
    }
  },
  methods: {
    userRate(e) {
      this.formData.customerSatisfactionRate = e
    },
    goUp() {
      this.$refs.addUserMainDiv.scrollTop = 0
      
    },
    goToListPage() {
      this.$router.push({ path: '/list/user' })
    },
    submit() {
      this.firstNameError = false
      this.lastNameError = false
      this.mobileError = false
      if (this.formData.firstName === null) {
        this.goUp()
        this.firstNameError = true
      }
      if (this.formData.lastName === null) {
        this.goUp()
        this.lastNameError = true
      }
      if (this.formData.mobile === null) {
        this.goUp()
        this.mobileError = true
      }
      if (!this.firstNameError && !this.lastNameError && this.formData.mobile !== null) {
        this.disableSubmit = true
        userDataProvider
          .addNewUser(this.formData)
          .then(res => {
            
            this.$router.push({ path: '/list/user' })
            this.disableSubmit = false
          })
          .catch(error => {
            if (error.response.status === 409) {
              this.goUp()
              
              this.mobileError = true
              this.mobileErrorText = error.response.data.message
            }
            this.disableSubmit = false
          })
      }
    },
    selectedProvince(event) {
      this.resetCityFlag = false
      this.$nextTick(() => {
        this.resetCityFlag = true
      })
      invoiceDataProvider
        .getCity({
          pageSize: 1000,
          pageNumber: 1,
          keyword: '',
          ProvinceId: event.key,
        })
        .then(res => {
          this.$store.dispatch('invoice/setCityData', res.data.data)
          this.searchedCityData = this.cityData
          this.cityDisabled = false
        })
    },
    searchedProvince(event) {
      this.searchedProvinceData = this.provinceData
      this.searchedProvinceData = this.provinceData.filter(item => {
        return item.value.includes(event)
      })
    },
    selectedCity(event) {
      this.formData.address.cityId = event.key
    },
    searchedCity(event) {
      this.searchedCityData = this.cityData
      this.searchedCityData = this.cityData.filter(item => {
        return item.value.includes(event)
      })
    },
    changeUserAvatar(payload) {
      this.cropperLoading = true
      fileMannager
        .addImage({
          base64image: payload,
        })
        .then(res => {
          this.cropperLoading = false
          
          this.UserAvatar = res.data.data.downloadUrl
          this.$bvModal.hide('chooseImage')
        })
      setTimeout(() => {
        this.formData.avataImageUrl = this.UserAvatar
      }, 2500)
    },
    tagListUpdate(payload) {
      for (let i = 0; i < payload.length; i++) {
        this.formData.tag.push({ title: payload[i] })
        this.FormTagData.tags.push({ title: payload[i] })
      }
    },
  },
  beforeMount() {
    this.forceUpdateFlag = false
    this.$nextTick(() => {
      invoiceDataProvider
        .getProvince({
          pageSize: 1000,
          pageNumber: 1,
          keyword: '',
        })
        .then(res => {
          this.$store.dispatch('invoice/setProvinceData', res.data.data)
          this.searchedProvinceData = this.provinceData
        })
      this.forceUpdateFlag = true
    })
  },
}
</script>

<style scoped lang="scss">
.addUserMainDiv {
  max-height: 88vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-behavior: smooth;
}
::-webkit-scrollbar {
  display: none;
}
.main {
  background: #ffffff;
  box-shadow: 0px 10px 20px rgba(18, 38, 63, 0.0313726);
  border-radius: 8px;
  padding: 30px;
}
.userInformation {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #444444;
}
.submitButton {
  font-size: 14px !important;
  padding: 8px 45px !important;
  color: white !important;
  background: #556ee6 !important;
  border: 1px solid #556ee6 !important;
  box-sizing: border-box !important;
  border-radius: 8px !important;
}
.buttonClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  direction: ltr;
}
.section {
  padding: 26px 30px;
  margin-bottom: 20px;
  background: #f8f9fa;
  border-radius: 6px;
}
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.userPic {
  font-size: 60px;
  color: #556ee6;
}
.choosePic {
  display: flex;
  cursor: pointer;
  margin-right: 30px;
  justify-content: center;
  align-items: center;
  color: white;
  background: #556ee6;
  border-radius: 2.6px;
  width: 99px;
  height: 28px;
}
.error-wrapper {
  text-align: center;
  * {
    color: #4a4a4a;
    font-style: normal;
    font-weight: normal;
  }

  .error-title {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 23px;
  }

  .error-text {
    font-size: 14px;
    line-height: 20px;
    margin: 25px 0;
  }
  button {
    font-size: 16px;
    line-height: 23px;
    background-color: transparent;
    outline: none;
    border: none;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .approveButton {
    padding: 6px 90px;
    color: white;
    background: #556ee6;
    border-radius: 4px;
  }
  .cancelButton {
    padding: 6px 90px;
    margin-left: 12px;
    color: white;
    background: #74788d;
    border-radius: 4px;
  }
}
.buttonClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  direction: ltr;
}
.submitButton {
  font-size: 14px !important;
  padding: 8px 45px !important;
  color: white !important;
  background: #556ee6 !important;
  border: 1px solid #556ee6 !important;
  box-sizing: border-box !important;
  border-radius: 4px !important;
}
.cancleButton {
  display: flex;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 23px;
  background: #74788d;
  box-sizing: border-box;
  border-radius: 4px;
}
.user-avatar {
  width: 67px;
  height: 67px;
  border-radius: 50%;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.alert-popUp {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  background: white;
  border: none;
  align-items: center;
  min-width: 450px;
  border-radius: 9px;
  height: 90px;
  text-align: right;
  position: fixed;
  z-index: 9999;
  bottom: 50px;
  right: 275px;
}
::v-deep .alert {
  padding: 0;
}
</style>
